import { defineMessages } from '../../utils/i18n'

export const editorMessages = defineMessages({
	file: { defaultMessage: 'File' },
	untitledProject: { defaultMessage: 'Untitled file' },
	downloadFile: { defaultMessage: 'Download' },
	copyToMyfiles: { defaultMessage: 'Copy to my workspace' },
	anonymousUser: { defaultMessage: 'Guest user' },
})
